import requests from './httpService';

const StudentService = {
  getAllStudent(id) {
    return requests.get(`/student/list/${id}`);
  },
//   upadeCity(body) {
//     return requests.put(`/city/${body.id}`,body); 
//   },
findStudentList(body){
  return requests.post(`/student/find`,body); 
},
getStudentAttendanceSummary(studentId, body){
  return requests.post(`/student/attendance-summary/${studentId}`, body);
},
getStudentActivitySummary(studentId, body){
  return requests.post(`/student/activity-summary/${studentId}`, body);
},
getStudentAssignmentSummary(studentId, body){
  return requests.post(`/student/assignment-summary/${studentId}`, body);
},
getStudentReportNotes(studentId, body){
  return requests.post(`/student/report-notes/${studentId}`, body);
},
getStudentQuestionnaireReport(studentId, body){
  return requests.post(`/student/questionnaire-report/${studentId}`, body);
},
getStudentMilestoneImages(studentId, body){
  return requests.post(`/student/milestone-images/${studentId}`, body);
},
  creteStudent(body){
    return requests.post('/student/add',body); 
  },
  getAllStudentById(id,body){
    return requests.post(`/student/list/${id}`,body); 
  },
  deleteStudent(id) {
    return requests.delete(`/student/${id}`);
  },
  deleteAllStudents(body) {
    return requests.post('/student/delete-many', body);
  },
  upadeStudent(body) {
    return requests.put(`/student/${body._id}`,body); 
  },
  updateParentStudentProfile(studentId, body) {
    return requests.put(`/student/parent-profile/${studentId}`, body);
  },
  getByIdStudent(id) {
    return requests.get(`/student/${id}` );
  },
  uploadImage(body) {
    return requests.post(`/student/uploadimage`,body);
  },
  deleteAzureImage(body) {
    return requests.post('/student/deleteazureimage', body);
  },
  promoteStudents(body) {
    return requests.post('/student/promote', body);
  },
  sendParentCredentials(studentId) {
    return requests.post(`/student/send-credentials/${studentId}`);
  },
  resetParentPassword(studentId, body = {}) {
    return requests.post(`/student/reset-password/${studentId}`, body);
  },
  creteImages(body){
    return requests.post('/image/add',body);
  },
};

export default StudentService;
